// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__329YT","bigColWidth":"Table_bigColWidth__2pbet","biggerColWidth":"Table_biggerColWidth__dt0xe","row":"Table_row__v6e5T","col":"Table_col__2ww4W"};